var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exercise analysis"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"card"},[_c('h5',[_vm._v("Records")]),_c('ExerciseTable',{attrs:{"id":_vm.id,"event":_vm.event}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }